export default {
    cancelText: '取消',
};



// WEBPACK FOOTER //
// ./components/search-bar/locale/zh_CN.tsx